import { ModalBody, ModalHeader, ModalProps } from 'UIKit/AlchemyModal'
import Box from 'UIKit/Box/Box'
import Flex from 'UIKit/Box/Flex'
import Text from 'UIKit/Text'
import TokenLogo from 'UIKit/TokenLogo'
import { ChainIdEnum } from 'config/constants/network'
import tokens from 'config/constants/tokens'
import { Token } from 'config/types'
import { TipDetails } from 'config/types/payment'
import { TipTransactionFilterTypeEnums } from 'config/types/transaction'
import useModal from 'hooks/useModal'
import { Trans, useTranslation } from 'react-i18next'
import { useAuthBy } from 'state/auth/hooks'
import { Icons } from 'svgs'
import colors from 'theme/ui/colors'
import { delayed } from 'utils'
import { getFullDisplayBalance } from 'utils/formatBalance'
import { showToast } from 'utils/toastify'
import { PAYMENT_MODAL_THEME, StickyButtonWrapper, StylePaymentModal } from '../../components/styles'
import TipDetailInfoes from './TipDetailInfoes'
import TipDetailModal from './TipDetailModal'
import TraditionalConfirmTipButton from './TraditionalConfirmTipbutton'
import WalletConfirmTipButton from './WalletConfirmTipButton'

interface ConfirmTipModalProps {
  details: TipDetails
  onSucceed?: () => void
}

const ConfirmTipToast: React.FC<{ token: Token; displayAmount: string }> = ({ token, displayAmount }) => {
  return (
    <Box minWidth="250px">
      <Flex alignItems="flex-start">
        <Flex flexDirection="column" alignItems="flex-start" justifyContent="flex-end">
          <Flex alignItems="center">
            <Icons.SuccessCheckIcon height="24px" fill={colors.success} />

            <Text ml="8px" fontSize="16px" bold color="success">
              <Trans>Tip sent successfully!</Trans>
            </Text>
          </Flex>

          <Flex mt="4px" ml="32px" alignItems="center">
            <TokenLogo token={token} width="20px" />
            <Text ml="6px" fontSize="14px">
              {displayAmount} {token.name}
            </Text>
          </Flex>
        </Flex>
      </Flex>
    </Box>
  )
}

const ConfirmTipModal: React.FC<ModalProps<ConfirmTipModalProps>> = ({ data: { details, onSucceed }, onDismiss }) => {
  const { isAuthByEmail, isAuthByWallet, isAuthByTelegram } = useAuthBy()
  const [onPresentTipDetailModal] = useModal(TipDetailModal)
  const { t } = useTranslation()

  const handlePresentTipDetailModal = async (responseData: TipDetails) => {
    if (responseData) {
      if (onSucceed) onSucceed()

      showToast(
        <ConfirmTipToast
          token={tokens[ChainIdEnum[details.network]]?.[details.currency]}
          displayAmount={getFullDisplayBalance(details.amount, 0)}
        />,
      )

      onPresentTipDetailModal({
        details: responseData,
        target: TipTransactionFilterTypeEnums.Send,
        activeDirectSendForm: true,
      })
    }

    await delayed(500)
    onDismiss()
  }

  return (
    <StylePaymentModal colorTheme={PAYMENT_MODAL_THEME} onDismiss={onDismiss}>
      <ModalHeader colorTheme={PAYMENT_MODAL_THEME} title={t('Confirm Tip')} />
      <ModalBody gap="20px">
        <TipDetailInfoes details={details} target={TipTransactionFilterTypeEnums.Send} hideCreateTime title="Tip" />

        <StickyButtonWrapper>
          {(isAuthByEmail || isAuthByTelegram) && (
            <TraditionalConfirmTipButton details={details} onConfirmed={handlePresentTipDetailModal} />
          )}
          {isAuthByWallet && <WalletConfirmTipButton onConfirmed={handlePresentTipDetailModal} details={details} />}
        </StickyButtonWrapper>
      </ModalBody>
    </StylePaymentModal>
  )
}

export default ConfirmTipModal
